import { useMemo } from 'react'
import { ScheduleType } from 'types/schedule'
import { StoreCalendarType } from 'types/storeCalendar'
import { TemporaryOpenDate } from 'types/calendar'
import { parseToDate } from 'lib/helper'

const useGeneratedDailyStocksByDefaultDayOfWeeks = (
  schedules: ScheduleType[],
  storeCalendars: StoreCalendarType[],
  confirmStoreCalendars: StoreCalendarType[],
  isConfirmOpenStoreCalendar: boolean
): TemporaryOpenDate[] => {
  // 店舗オープン時刻の変更に伴う受渡解禁時刻の上書き
  return useMemo(() => {
    if (!isConfirmOpenStoreCalendar) return []
    const generatedDailyStocksByDefaultDayOfWeeks = confirmStoreCalendars.reduce(
      (prev: TemporaryOpenDate[], storeCalendar) => {
        // 既存の storeCalendars から変更がない場合はスキップ
        if (
          storeCalendars.some((calendar) => {
            return (
              calendar.date === storeCalendar.date &&
              calendar.status === storeCalendar.status &&
              calendar.default_day_of_week === storeCalendar.default_day_of_week &&
              calendar.open_time === storeCalendar.open_time &&
              calendar.order_start_time === storeCalendar.order_start_time &&
              calendar.last_order_time === storeCalendar.last_order_time &&
              calendar.last_pickup_time === storeCalendar.last_pickup_time
            )
          })
        ) {
          return prev
        }

        schedules.forEach((schedule) => {
          if (
            schedule.type !== 'daily' ||
            schedule.days_of_week.length === 0 ||
            schedule.default_stocks.every((defaultStock) => {
              return defaultStock.pickupable_time === '' && defaultStock.stock === 0
            })
          )
            return
          if (!storeCalendar.default_day_of_week) return
          if (schedule.days_of_week.includes(storeCalendar.default_day_of_week)) {
            prev.push({ breadRef: schedule.bread_ref, date: parseToDate(storeCalendar.date) })
          }
        })
        return prev
      },
      []
    )
    return generatedDailyStocksByDefaultDayOfWeeks
  }, [schedules, confirmStoreCalendars, isConfirmOpenStoreCalendar])
}

export default useGeneratedDailyStocksByDefaultDayOfWeeks
